import NiceModal from "@ebay/nice-modal-react";
import { useEffect, useState } from "react";
import {
  Outlet,
  useLocation,
  useSearchParams
} from "react-router";
import "./modals";
import {
  initSession,
  sendSessionEv
} from "@api/events";
import Loading from "@components/Statuses/Loading";
import Footer from "./components/Footer";
import HealthWarning from "@components/HealthWarning";

function Layout() {
  const [searchParams] = useSearchParams();
  const returnURL = searchParams.get("returnURL")
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if(returnURL) sessionStorage.setItem("returnURL", returnURL)
  }, [returnURL])

  const initEventSession = ( event, value ) => {
    initSession( (result) => {
      if(result.status.success) {
        sessionStorage.setItem("sId", result.data.sessionId)
        sendSessionEv( event, value )
      }
    } )
  }

  const sendSessionEvent = ( event, value ) => {
    if(sessionStorage.getItem("sId")) {
      sendSessionEv( event, value )
    } else {
      initEventSession( event, value )
    }
  }

  useEffect(() => {
    setLoading(false)
    // sendSessionEvent("pageView", pathname.replaceAll("/", "_"))

    return () => { setLoading(false) }
  }, [pathname]);

  return (
    <NiceModal.Provider>
      {loading ? (
        <Loading fullScreen>
          <p>Gib uns einen Augenblick</p>
        </Loading>
      ) : (
        <main className="app-wrapper">
          <Outlet />
          <Footer/>
          <HealthWarning/>
        </main>
      )}
    </NiceModal.Provider>
  );
}

export default Layout;
